import { Box, Table } from '@factorialco/deprecated-design-system'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { SkeletonValue } from 'modules/finance/components/FinancialWorkspace/components/SkeletonValue'
import { useHeaders } from 'modules/finance/components/FinancialWorkspace/components/Table/hooks/useHeaders'
import { StickyCell } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Row/StickyCell'

export const LoadingRow = ({
  ref,
  level,
}: {
  ref?: React.RefObject<HTMLTableRowElement>
  level?: number
}) => {
  const headers = useHeaders()
  const { hasComparisonDate } = useFinancialWorkspace()

  return (
    <Table.Row trRef={ref}>
      <StickyCell title="" level={level}>
        <SkeletonValue width="s80" />
      </StickyCell>
      {headers.map((_, index) => {
        const withBorder =
          hasComparisonDate && index !== headers.length - 1 && (index + 1) % 3 === 0
        return (
          <Table.Cell
            wide
            key={`${index}`}
            style={{
              borderRight: withBorder ? '1px solid #E2E2E5' : undefined,
            }}
          >
            <Box flexDirection="row" justifyContent="flexEnd">
              <SkeletonValue width="s48" />
            </Box>
          </Table.Cell>
        )
      })}
    </Table.Row>
  )
}
